<template>
  <StandardDialogFullScreen opacity="1">
    <template #dialog>
      <router-view style="z-index: 20"/>
    </template>
    <template #header-workpackages>
      <StandardFlexBox
        v-if="!create"
        direction="column"
      >
        <TText
          v-if="material.owner"
          value="Creator{colon} {firstName} {lastName} - {email}"
          :value_props="{
            colon: ':',
            firstName: material.owner.first_name,
            lastName: material.owner.last_name,
            email: material.owner.email,
          }"
          font_weight="400"
        />
        <TText
          value="Updated{colon} {timestamp}"
          :value_props="{
            colon: ':',
            timestamp: material.updated.substring(0, 16),
          }"
          font_weight="400"
        />
      </StandardFlexBox>
      <StandardFlexBox
        class="font-weight-light ml-6"
        width="calc(100vw - 450px)"
      >
        <StandardDataField
          v-for="(hashtag, index) in material.hashtags"
          :key="index"
          class="user-select-none ml-1"
          :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
          one_liner="true"
          readonly="true"
          :value="hashtag.tag"
          width="24%"
        >
          <template #prepend-slot>
            <div class="user-select-none">#</div>
          </template>
          <template #append-slot>
            <StandardDeleteButton
              v-if="!read_only"
              :zoom="1"
              @clickDelete="create
                ? deleteWBLObject({
                    path: [
                      {material: ''},
                      {hashtags: ''}
                    ],
                    index: index,
                  })
                : removeHashtag(index)"
            />
          </template>
        </StandardDataField>
        <StandardDataField
          v-if="!read_only"
          class="ml-1"
          :key="`addhashtag_${update_key_add_hashtag}`"
          :color="$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'"
          :text_color="$vuetify.theme.isDark ? 'white' : 'black'"
          one_liner="true"
          @changeValue="
          create?
          createWBLObject({
            path: [
              {material: ''},
              {hashtags: ''}
            ],
            wbl_object: {
              tag: $event.replace(/\s/g,'')
            }
          })
          :
          addHashtag($event),
          update_key_add_hashtag++
          "
        >
        <template #prepend-slot>
          <div class="user-select-none">#</div>
        </template>
        </StandardDataField>
      </StandardFlexBox>
    </template>
    <template #header-close>
      <template v-if="!create">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
        <v-btn icon
          @click="$router.push({
            name: nav_back?nav_back:`${location}Materials`
            })"
            v-on="on"
            v-bind="attrs"
            color="green"
          >
              <v-icon>done</v-icon>
        </v-btn>
      </template>
      <span>{{$t('WorkBench.Editor.Workpackage.Toolbar.done')}}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-if="!read_only && $route.params.template_type === 'custom'"
            v-on="on"
            v-bind="attrs"
            @click="createWBObject({
              url: [
                {[`${prefix}materials`]: material_id},
                {copyOwnMaterial: ''}
              ],
              url_suffix: '?show=showWithEntitiesNormalized'
              }).then(() => {
                $router.push({
                  name: `${location}Materials`
                })
              })"
            >
            <v-icon>content_copy</v-icon>
          </v-btn>
        </template>
        <span>Copy Material</span>
      </v-tooltip>
        <!-- upload to community -->
        <TUploadButton
          v-if="!read_only"
          icon="people"
          :value="material.is_community_suggested"
          tooltip="Upload Material to Community"
          @upload="updateWBObject({
            url: [
              {[`${prefix}materials`]: material_id},
            ],
            update: {
              is_community_suggested: true
            }
          })"
        />
        <!-- community download -->
        <template v-if="$route.params.template_type === 'community'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              :color="material.likes.some(like => like.user.id === getUserId)?'blue':'grey'"
              v-on="on"
              v-bind="attrs"
              @click="
              createWBObject({
                url: [
                  {materials: '0/copyfromcommunity'},
                  {showWithEntitiesNormalized: ''},
                ],
                wb_object: {
                  cmaterial_id: material.id
                }
              }).then(() => {
                material.likes.some(like => like.user.id === getUserId)?
                '':
                updateWBObject({
                  url: [
                  {cmaterials: material.id},
                  {like: ''},
                  ],
                  update: {
                    likes: getLikes(material.likes)
                  }
                })
              })"
              >
              <v-icon class="mr-5">download</v-icon>
              {{material.likes.length}}
            </v-btn>
            </template>
            <span>Download Material</span>
          </v-tooltip>
        </template>
        <!-- company download -->
        <template v-if="$route.params.template_type === 'company'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                text
                :color="material.likes.some(like => like.user.id === getUserId)?'blue':'grey'"
                v-on="on"
                v-bind="attrs"
                @click="
                createWBObject({
                  url: [
                    {materials: '0/copyfrombusiness'},
                    {showWithEntitiesNormalized: ''},
                  ],
                  wb_object: {
                    bmaterial_id: material.id
                  }
                }).then(() => {
                  material.likes.some(like => like.user.id === getUserId)?
                  '':
                  updateWBObject({
                    url: [
                    {bmaterials: material.id},
                    {like: ''},
                    ],
                    update: {
                      likes: getLikes(material.likes)
                    }
                  })
                })"
                >
                <v-icon class="mr-5">download</v-icon>
                {{material.likes.length}}
              </v-btn>
            </template>
            <span>Download Material</span>
          </v-tooltip>
        </template>
        <!-- upload to company -->
        <template v-if="!read_only && hasPermission('Business READ') && $route.params.template_type === 'custom'">
          <TUploadButton
            v-if="!read_only"
            icon="work"
            :counter="getWBObjectsFiltered({type: 'bmaterials',
              filter: {
                name: material.name,
                owner: material.owner
              }
            }).length"
            tooltip="Upload Material to Company"
            @upload="createWBObject({
              template_type: 'company',
                url: [
                  {bmaterials: 'createfrommaterial'},
                  {showWithEntitiesNormalized: ''}
                ],
                wb_object: {
                  material_id: material.id
                }
              })"
          />
        </template>
        <!-- delete material -->
        <StandardDeleteBtn
          v-if="
            !read_only && prefix === ''
            "
          :el="material"
          tooltip="Delete Material"
          @deleteClick="deleteWBObject({
                url: [
                  {[`materials`]: material.id}
                ]
              }),
              $router.push({
                name: `${location}Materials`
                })"

          />
        <StandardDeleteBtn
          v-else-if="
            !read_only ||
            ($route.params.template_type === 'company' && hasPermission('BWorkPackage DELETE')) ||
            ($route.params.template_type === 'community' && hasPermission('CWWorkPackage DELETE'))
            "
          :el="material"
          :tooltip="$t('WorkBench.Editor.Workpackage.Toolbar.delete')"
          @deleteClick="deleteWBObject({
                url: [
                  {[`${prefix}materials`]: material.id}
                ]
              }),
              $router.push({
                name: `WorkBenchMaterials`
                })"

          />
      </template>
      <template v-else-if="!create">
        <v-btn icon
          @click="$router.push({
            name: nav_back?nav_back:`${location}Materials`
            })"
          >
          <v-icon color="green">done</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-btn
          color="orange"
          @click="
          resetMaterial()"
          >
          <v-icon
            >
          restart_alt
        </v-icon>
          Reset
        </v-btn>
        <v-spacer/>
        <v-btn
          class="ml-2"
          color="green"
          @click="
          createWBObject({
            url: [
              {[`${prefix}materials`]: ''},
              {showWithEntitiesNormalized: ''}
            ],
            wb_object: material
            }).then(() => {
                $router.push({
                  name: `${location}Materials`
                })
              })
            "
          >
          <v-icon
            >
          add
        </v-icon>
          Create
        </v-btn>
        <v-btn
          depressed
          class="ml-2"
          color="grey darken-4"
          @click="$router.push({
            name: nav_back?nav_back:`${location}Materials`
            })"
          >
          <v-icon
            >
          close
        </v-icon>
          Cancel
        </v-btn>
      </template>
    </template>
    <template #content>
      <!-- EDITOR START -->
      <div class="workbench-material-editor-container" :style="`background-color: ${getColor(bg)}; color: ${getColor(fg)};`">
        <!-- GENERAL AND ATTRIBUTES -->
        <div class="pa-2 workbench-material-editor-scrollable">
          <!-- GENERAL -->
          <TText value="General" :color="fg" font_weight="400" />
          <DisableableInputField
            label="Name"
            align="left"
            :background_color="bg"
            :foreground_color="fg"
            :value="material.name"
            :is_disabled="read_only"
            @change="genericUpdate({
              name: $event
            })"
          />
          <TextArea
            label="Description"
            :background_color="bg"
            :foreground_color="fg"
            :value="material.description"
            :is_disabled="read_only"
            resize
            font_size="10"
            font_weight="300"
            @change="genericUpdate({
              description: $event
            })"
          />

          <!-- ATTRIBUTES -->
          <TText value="Attributes" :color="fg" font_weight="400" />
          <div class="workbench-material-editor-general-attribute-grid">
            <InputAndSourceField
              v-for="attr in attributes"
              :key="`attribute_${attr.label}`"
              :label="attr.label"
              :icon="attr.icon"
              :read_only="read_only"
              :val="material[attr.value]"
              :source_val="material[attr.source]"
              :units="attr.units"
              :input_type="attr.input_type"
              :input_mode="attr.input_mode"
              :background_color="bg"
              :foreground_color="fg"
              @change="genericUpdate({
                [attr.value]: attr.input_type === 'number'?parseFloat(parseFloat($event).toFixed(2)):$event
              })"
            />
          </div>
        </div>

        <!-- MAPABLE PROPERTY SETS -->
        <div class="pa-2 workbench-material-editor-scrollable">
          <!-- PROPERTY SETS -->
          <TText value="Property sets" :color="fg" font_weight="400" />
          <CollapsableCategory
            v-for="(propertyset, propset_index) in material_propertysets"
            :key="`propertyset${propset_index}`"
            class="workbench-material-editor-relative"
            :description="propertyset.name"
            :font_weight="300"
            :color="fg"
          >
            <!-- EDIT SET -->
            <template #header-middle>
              <TIconButton
                class="workbench-material-editor-ticon"
                icon="pencil"
                tooltip="Edit"
                size="32"
                :color="fg"
                left
                :is_clicked="cached_property_set.id === propertyset.id"
                @clickIcon="cachePropertySet(propset_index)"
              />
            </template>

            <!-- ACTUAL PROPERTIES OF SET -->
            <template #content="{ is_collapsed }">
              <TransitionAccordion>
                <div v-if="!is_collapsed">
                  <Property
                    v-for="(property, prop_index) in getProperties(propertyset.properties)"
                    :key="`property${property.id}`"
                    :property="property"
                    :editable="false"
                    :mapable="true"
                    :is_first="prop_index === 0"
                    :foreground_color="fg"
                    :background_color="bg"
                    @mapValue="mapProperty(propertyset.id, propset_index, property.id, prop_index, $event.value)"
                  />
                </div>
              </TransitionAccordion>
            </template>
          </CollapsableCategory>
        </div>

        <!-- PROPERTY SET FACTORY -->
        <div class="workbench-material-editor-scrollable">
          <!-- PROPERTY SET -->
          <div class="pa-2 workbench-material-editor-vertical-division">
            <TText :value="isNewPropertySet ? 'New property set' : 'Update property set'" :color="fg" font_weight="400" />
            <DisableableInputField
              label="Name"
              align="left"
              :background_color="bg"
              :foreground_color="fg"
              :value="cached_property_set.name"
              placeholder="Property set name..."
              :is_disabled="read_only || create"
              @change="cached_property_set.name = $event.trim();"
            />
            <TextArea
              label="Description"
              :background_color="bg"
              :foreground_color="fg"
              :value="cached_property_set.description"
              :placeholder="read_only || create ? '' : 'Property set description...'"
              :is_disabled="read_only || create"
              resize
              font_size="10"
              font_weight="300"
              @change="cached_property_set.description = $event.trim();"
            />

            <!-- SAVE PROPERTY SET -->
            <div class="workbench-material-editor-button-container">
              <ButtonOutlined
                v-if="!isNewPropertySet"
                value="Cancel"
                icon="sign-close"
                :color="fg"
                padding="0 8px"
                @buttonClicked="resetPropertySet()"
              />
              <ButtonOutlined
                v-if="!isNewPropertySet"
                value="Delete"
                icon="bin"
                :color="fg"
                padding="0 8px"
                @buttonClicked="deletePropertySet()"
              />
              <TTooltip
                :hidden="cached_property_set.name.length > 0"
                :value="create ? 'Material needs to be created first' : 'Property set needs a name'"
              >
                <ButtonOutlined
                  :value="isNewPropertySet
                    ? 'Save property set'
                    : 'Update property set'"
                  :icon="isNewPropertySet
                    ? 'floppy-disc'
                    : 'cycle'"
                  :is_disabled="!(cached_property_set.name.length) || create"
                  :color="fg"
                  padding="0 8px"
                  @buttonClicked="isNewPropertySet
                    ? createPropertySet()
                    : updatePropertySet()"
                />
              </TTooltip>
            </div>
          </div>

          <div class="workbench-material-editor-full-width workbench-material-editor-horizontal-border" />

          <div class="pa-2 workbench-material-editor-vertical-division workbench-material-editor-neutral-flex">
            <!-- NEW PROPERTY -->
            <TText
              :value="isNewProperty ? 'New property' : 'Update property'"
              :color="isNewPropertySet ? getTranspHexColor(getColor(fg), .5) : fg"
              font_weight="400"
            />
            <template v-for="input in property_inputs">
              <DisableableInputField
                v-if="!input.options"
                :key="`property_input_field_${input.label}`"
                :label="input.label"
                :placeholder="input.placeholder"
                :background_color="bg"
                :foreground_color="isNewPropertySet ? getTranspHexColor(getColor(fg), .5) : fg"
                align="left"
                :value="cached_property[input.value]"
                :is_disabled="read_only || isNewPropertySet"
                @change="cached_property[input.value] = $event.trim()"
              />
              <DropDownOutlinedFlat
                v-else
                :key="`property_input_dropdown_${input.label}`"
                class="workbench-material-editor-full-width"
                :label="input.label"
                :background_color="bg"
                :foreground_color="isNewPropertySet ? getTranspHexColor(getColor(fg), .5) : fg"
                font_size="10"
                :options="input.options"
                :value="input.options.find(option => option.value === cached_property[input.value])"
                :is_disabled="read_only || isNewPropertySet"
                @change="cached_property[input.value] = $event.trim()"
              />
            </template>

            <!-- ADD PROPERTY TO SET -->
            <div class="workbench-material-editor-button-container">
              <ButtonOutlined
                v-if="!isNewProperty"
                value="Cancel"
                icon="sign-close"
                :color="fg"
                padding="0 8px"
                @buttonClicked="resetProperty()"
              />
              <TTooltip
                :hidden="cached_property.name.length > 0 && cached_property.value.length > 0 || isNewPropertySet"
                value="Property needs a name and a value"
              >
                <ButtonOutlined
                  :value="isNewProperty
                    ? 'Add property to set'
                    : 'Update property'"
                  :icon="isNewProperty
                    ? 'sign-plus'
                    : 'cycle'"
                  :is_disabled="!(cached_property.name.length > 0 && cached_property.value.length > 0)"
                  :color="fg"
                  padding="0 8px"
                  @buttonClicked="isNewProperty
                    ? createProperty()
                    : updateProperty()"
                />
              </TTooltip>
            </div>

            <!-- DISPLAY PROPERTIES IN PROPERTY SET -->
            <TText
              value="Properties"
              :color="isNewPropertySet ? getTranspHexColor(getColor(fg), .5) : fg"
              font_weight="400"
            />
            <div class="workbench-material-editor-properties-scroll" :style="`border-color: ${isNewPropertySet ? getTranspHexColor(getColor(fg), .5) : fg};`">
              <Property
                v-for="(property, index) in cached_property_set.properties"
                :key="`property${index}`"
                :property="property"
                :editable="isNewProperty"
                :mapable="false"
                :is_first="index === 0"
                :foreground_color="update_property_index === index ? bg : fg"
                :background_color="update_property_index === index ? fg : bg"
                @click="cacheProperty(index)"
                @delete="deleteProperty(index)"
              />
              <!-- @delete="cached_property_set.properties.splice(index, 1)" -->
              <TText
                v-if="!cached_property_set.properties.length"
                value="No properties added yet..."
                size="10"
                color="grey darken-2"
              />
            </div>
          </div>
        </div>

        <!-- MATERIAL API -->
        <div class="pa-2 workbench-material-editor-scrollable">
          <!-- MATERIAL API -->
          <TText :color="fg" text="Property sets from MATERIAL.api" font_weight="400" />
          <SearchBar
            placeholder="Search MATERIAL.api"
            min_height="40"
            :foreground_color="fg"
            :is_disabled="read_only || create || hasPermission('Material API READ') === false"
            @search="queryMaterialAPI($event)"
          />
          <TText v-if="hasPermission('Material API READ')" :color="fg" size="10" :value="materialapi_search" />
          <TText v-else :color="fg" size="10" value="You don't have the Material API Permission." />

          <CollapsableCategory
            v-for="(propset, propset_index) in material_api_property_sets"
            :key="`materialapipropset${propset_index}`"
            class="workbench-material-editor-relative"
            :description="propset.name"
            :font_weight="300"
            :color="fg"
          >
            <template #header-middle>
              <TIconButton
                class="workbench-material-editor-ticon"
                icon="sign-plus"
                tooltip="Add property set to material"
                left
                size="32"
                :color="fg"
                @clickIcon="addPropertySetToMaterialFromAPI(propset, propset_index)"
              />
            </template>
            <template #content="{ is_collapsed }">
              <TransitionAccordion>
                <div v-if="!is_collapsed">
                  <Property
                    v-for="(property, index) in propset.properties"
                    :key="`newproperty${index}`"
                    :property="property"
                    :editable="false"
                    :mapable="false"
                    :is_first="index === 0"
                    :foreground_color="fg"
                    :background_color="bg"
                  />
                </div>
              </TransitionAccordion>
            </template>
          </CollapsableCategory>
        </div>
      </div>
    </template>
  </StandardDialogFullScreen>
</template>

<script>
  import { TColor } from '@/mixins/TColor.mixin.js';
  import { WorkBenchMaterialMixin } from '@/mixins/WorkBenchMaterial.mixin.js';
  import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue';
  import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
  import ButtonOutlined from '@/components/WorkPackageWIP/ButtonOutlined.component.vue';
  import InputAndSourceField from '@/modules/General/InputAndSourceField.module.vue';
  import TextArea from '@/components/WorkPackageWIP/TextArea.component.vue';
  import TText from '@/components/Taktify/TText.component.vue';
  import DropDownOutlinedFlat from '@/components/WorkPackageWIP/DropDownOutlinedFlat.component.vue';
  import TIconButton from '@/components/Taktify/TIconButton.component.vue';
  import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';
  import SearchBar from '@/components/WorkPackageWIP/SearchBar.component.vue';

  import { mapGetters, mapActions } from 'vuex';
  export default {
    components: {
      DisableableInputField,
      CollapsableCategory,
      ButtonOutlined,
      InputAndSourceField,
      TextArea,
      TText,
      DropDownOutlinedFlat,
      TIconButton,
      TransitionAccordion,
      SearchBar,
    },

    mixins: [
      TColor,
      WorkBenchMaterialMixin,
    ],

    props: [
      'material_id',
      'create',
      'nav_back',
      'location',
      'read_only'
    ],

    data: function () {
      return {
        selecected_right_part_tab: 'property_sets',
        cached_property_set: {
          name: '',
          description: '',
          properties: []
        },
        material_api_property_sets: [],
        materialapi_search: 'Hint: Press Enter to search...',
        cached_property: {
          name: '',
          description: '',
          value: '',
          data_type: 'String',
        },
        update_property_index: -1,
        attributes: [
          { label: 'Price', icon: 'currency', value: 'price', source: 'price_source', units: [{value: 'unit', text: 'unit'},], input_type: 'number', input_mode: 'numeric', },
          { label: 'Carbon dioxide', icon: 'co2', value: 'carbon_dioxide', source: 'carbon_dioxide_source', units: [{value: 'unit', text: 'unit'},], input_type: 'number', input_mode: 'numeric', },
          { label: 'Height', icon: 'height', value: 'height', source: 'height_source', units: [{value: 'unit', text: 'unit'},], input_type: 'number', input_mode: 'numeric', },
          { label: 'Length', icon: 'length', value: 'length', source: 'length_source', units: [{value: 'unit', text: 'unit'},], input_type: 'number', input_mode: 'numeric', },
          { label: 'Width', icon: 'width', value: 'width', source: 'width_source', units: [{value: 'unit', text: 'unit'},], input_type: 'number', input_mode: 'numeric', },
          { label: 'Weight', icon: 'weight', value: 'weight', source: 'weight_source', units: [{value: 'unit', text: 'unit'},], input_type: 'number', input_mode: 'numeric', },
          { label: 'Custom ID', icon: 'hashtag', value: 'custom_id', source: 'custom_id_source', input_type: 'text', input_mode: 'text', },
          { label: 'Manufacturer Name', icon: 'factory', value: 'manufacturer_name', source: 'manufacturer_name_source', input_type: 'text', input_mode: 'text', },
          { label: 'GITN', icon: 'barcode', value: 'global_trade_item_number', source: 'global_trade_item_number_source', input_type: 'text', input_mode: 'text', },
        ],
        property_inputs: [
          { label: 'Name', value: 'name', placeholder: 'Property name...'  },
          { label: 'Description', value: 'description', placeholder: 'Property description...' },
          { label: 'Value', value: 'value', placeholder: 'Property value...' },
          { label: 'Data type', value: 'data_type', options: [{value: 'String', text: 'Text'}, {value: 'Number', text: 'Number'}, {value: 'Boolean', text: 'Boolean'}] },
        ],
        bg: 'grey',
        fg: 'black',
      };
    },

    computed: {
      material_propertysets(){
        if (this.create) {
          return this.material.propertysets;
        } else {
          if (this.location === 'TaktPlanWorkPackageMaterialStep') {
            return this.getUObjects({
              type: 'propertysets',
              ids: this.material.propertysets
            });
          } else {
            return this.getWBObjects({
              type: 'propertysets',
              ids: this.material.propertysets
            });
          }
        }
      },

      isNewPropertySet() {
        return this.cached_property_set.id === undefined;
      },

      isNewProperty() {
        return this.cached_property.id === undefined;
      },

      ...mapGetters('Auth', [
        'getUser',
        'hasPermission'
      ]),

      ...mapGetters('Ultra', [
        'getUObjects',
        'getUObject'
      ]),

      ...mapGetters('Material', [
        'getMaterial',
      ]),
    },

    methods: {
      getProperties(ids){
        if (this.create) {
          // ids array is properties array in create
          return ids;
        } else {
          return this.getWBObjects({
            type: 'properties',
            ids: ids
          });
        }
      },

      genericUpdate(update){
        if (this.create) {
          let path = [
            {material: ''},
          ];
          this.updateWBLObject({
            path: path,
            update: update,
          });
        } else {
          let url = [
            {[`${this.prefix}materials`]: this.material_id},
          ];
          this.updateWBObject({
            url: url,
            update: update
          });
        }
      },

      addPropertySetToMaterialFromAPI(propset, index){
        let self = this;
        if (this.create) {
          // allways custom
          let url = [
            { material: ''},
            { propertysets: '' },
          ];
          this.createWBLObject({
            path: url,
            wbl_object: propset
          }).then(() => {
            self.material_api_property_sets.splice(index, 1);
          });
        }
        else {
          if (this.$route.template_type === 'project') {
            let url = [
              {[`tmaterials`]: this.material_id},
              { propertysets: '' },
              { showWithEntitiesNormalized: ''}
            ];
            this.createUObject({
              url: url,
              wb_object: propset
            }).then(() => {
              self.material_api_property_sets.splice(index, 1);
            });
          }
          else {
            let url = [
              {[`${this.prefix}materials`]: this.material_id},
              { propertysets: '' },
              { showWithEntitiesNormalized: ''}
            ];
            this.createWBObject({
              url: url,
              wb_object: propset
            }).then(() => {
              self.material_api_property_sets.splice(index, 1);
            });
          }
        }
      },

      createPropertySet(){
        if (this.create) {
          let url = [
            { material: ''},
            { propertysets: '' },
          ];
          this.createWBLObject({
            path: url,
            wbl_object: this.cached_property_set
          }).then(() => {
            this.cachePropertySet(this.material_propertysets.length - 1);
          });
        }
        else {
          if (this.$route.template_type === 'project') {
            let url = [
              { [`tmaterials`]: this.material_id },
              { propertysets: '' },
              { showWithEntitiesNormalized: ''}
            ];
            this.createUObject({
              url: url,
              wb_object: this.cached_property_set
            }).then(() => {
              this.cachePropertySet(this.material_propertysets.length - 1);
            });
          }
          else {
            let url = [
              { [`${this.prefix}materials`]: this.material_id },
              { propertysets: '' },
              { showWithEntitiesNormalized: ''}
            ];
            this.createWBObject({
              url: url,
              wb_object: this.cached_property_set
            }).then(() => {
              this.cachePropertySet(this.material_propertysets.length - 1);
            });
          }
        }
      },

      createProperty() {
        if (this.create) {
          let url = [
            { material: ''},
            { propertysets: '' },
            { properties: '' },
          ];
          this.createWBLObject({
            path: url,
            wbl_object: this.cached_property,
          }).then((res) => {
            this.cached_property.id = res;
            this.cached_property_set.properties.push(this.cached_property);
            this.resetProperty();
          });
        }
        else {
          if (this.$route.template_type === 'project') {
            let url = [
              { [`tmaterials`]: this.material_id },
              { propertysets: this.cached_property_set.id },
              { properties: '' },
              { showWithEntitiesNormalized: ''}
            ];
            this.createUObject({
              url: url,
              wb_object: this.cached_property
            }).then((res) => {
              this.cached_property.id = res;
              this.cached_property_set.properties.push(this.cached_property);
              this.resetProperty();
            });
          }
          else {
            let url = [
              { [`${this.prefix}materials`]: this.material_id },
              { propertysets: this.cached_property_set.id },
              { properties: '' },
              { showWithEntitiesNormalized: ''}
            ];
            this.createWBObject({
              url: url,
              wb_object: this.cached_property
            }).then((res) => {
              this.cached_property.id = res;
              this.cached_property_set.properties.push(this.cached_property);
              this.resetProperty();
            });
          }
        }
      },

      updatePropertySet(){
        if (this.$route.template_type === 'projects') {
          // TODO: CHECK HOW TO IMPLEMENT THIS IN PROJECT
          console.log("update in project not implemented yet");
        }
        else {
          let url = [
            // { projects: 0 },
            { [`${this.prefix}materials`]: this.material_id },
            { propertysets: this.cached_property_set.id },
          ];

          this.updateWBObject({
            url: url,
            update: {
              name: this.cached_property_set.name,
              description: this.cached_property_set.description,
            },
          });
        }
      },

      updateProperty() {
        this.cached_property_set.properties[this.update_property_index] = JSON.parse(JSON.stringify(this.cached_property));

        if (this.$route.template_type === 'projects') {
          // TODO: CHECK HOW TO IMPLEMENT THIS IN PROJECT
          console.log("update in project not implemented yet");
        } else {
          let url = [
            { [`${this.prefix}materials`]: this.material_id },
            { propertysets: this.cached_property_set.id },
            { properties: this.cached_property_set.properties[this.update_property_index].id },
          ];

          this.updateWBObject({
            url: url,
            update: {
              name: this.cached_property.name,
              description: this.cached_property.description,
              value: this.cached_property.value,
              data_type: this.cached_property.data_type,
            },
          });
        }

        this.resetProperty();
      },

      deletePropertySet() {
        if (this.$route.template_type === 'projects') {
          // TODO: CHECK HOW TO IMPLEMENT THIS IN PROJECT
          console.log("delete in project not implemented yet");
        } else {
          let url = [
            {[`${this.prefix}materials`]: this.material_id},
            { propertysets: this.cached_property_set.id },
          ];

          this.deleteWBObject({
            url: url,
          }).then(() => {
            this.resetPropertySet();
          });
        }
      },

      deleteProperty(index) {
        let property_id = this.cached_property_set.properties[index].id;

        if (this.$route.template_type === 'projects') {
          // TODO: CHECK HOW TO IMPLEMENT THIS IN PROJECT
          console.log("delete in project not implemented yet");
        } else {
          let url = [
            { [`${this.prefix}materials`]: this.material_id },
            { propertysets: this.cached_property_set.id },
            { properties: property_id },
          ];

          this.deleteWBObject({
            url: url,
          }).then(() => {
            this.resetProperty();
            this.cached_property_set.properties.splice(index, 1);
          });
        }
      },

      resetPropertySet(){
        this.cached_property_set = {
          name: '',
          description: '',
          properties: []
        };
        this.resetProperty();
      },

      resetProperty(){
        this.cached_property = {
          name: '',
          description: '',
          value: '',
          data_type: 'String',
        };
        this.update_property_index = -1;
      },

      queryMaterialAPI(search){
        this.materialapi_search = 'Searching...';
        this.material_api_property_sets = [];
        this.requestMaterials(search).then(() => {
          for (let i = 0; i < this.getMaterial.length; i++) {
            let name = this.getMaterial[i]['Name (en)'];
            if (name.length > 100) {
              name = name.substring(0,97) + '...' ;
            }
            let set = {
              name: name,
              description: '(From MATERIAL.api)',
              properties: []
            };
            let keys = Object.keys(this.getMaterial[i]);
            keys.forEach((key) => {
              let data_type = 'String';
              let val = this.getMaterial[i][key];
              if ( !isNaN(val) ) {
                data_type = 'Number';
              }
              let prop = {
                name: key,
                description: key,
                value: val,
                data_type: data_type,
              };
              set.properties.push(prop);
            });
            this.material_api_property_sets.push(set);
          }
        
          if(this.getMaterial.length == 0){
            this.materialapi_search = 'No results found';
          } else {
            this.materialapi_search = 'Results for ' + search + ': ' + this.getMaterial.length;
          }
        });
        // cached_property_set_material_api
      },

      cacheProperty(prop_index) {
        this.update_property_index = prop_index;
        this.cached_property = JSON.parse(JSON.stringify(this.cached_property_set.properties[prop_index]));
      },

      cachePropertySet(propset_index) {
        this.cached_property_set = JSON.parse(JSON.stringify(this.material_propertysets[propset_index]));

        let prop_ids = this.cached_property_set.properties;
        let properties = this.getProperties(prop_ids);
        delete this.cached_property_set.properties;
        this.cached_property_set.properties = properties;
        this.resetProperty();
      },

      mapProperty(propertyset_id, propset_index, property_id, prop_index, attr){
        let propset = this.getWBObject({type: 'propertysets', id: propertyset_id});
        let prop = this.getWBObject({type: 'properties', id: property_id});
        let val = prop.value;
        let update = {
          [attr]: !isNaN(parseFloat(val))?parseFloat(val):val,
          [`${attr}_source`]: `${propset.name} ${prop.name}`,
        };
        console.log('update', update);
        this.genericUpdate(update);
      },

      ...mapActions('Material', [
        'requestMaterials',
      ]),

      ...mapActions('Ultra', [
        'updateUObject'
      ])
    },
  }
</script>

<style lange="css" scroped>
  .workbench-material-editor-container {
    display: flex;
    height: calc(100% - 30px);
    overflow-x: auto;
  }
  .workbench-material-editor-scrollable {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    grid-gap: 4px;
    flex: 1 1 0px;
    border-right: 1px solid;
    color: inherit;
    min-width: 400px;
  }
  .workbench-material-editor-vertical-division {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    grid-gap: 4px;
    color: inherit;
  }
  .workbench-material-editor-button-container {
    align-self: flex-end;
    display: flex;
    grid-gap: 8px;
  }
  .workbench-material-editor-properties-scroll {
    overflow-y: auto;
    position: relative;
    flex-grow: 1;
    border: 1px solid;
    border-radius: 4px;
    padding: 4px;
    min-height: 300px;
  }
  .workbench-material-editor-full-width {
    width: 100%;
  }
  .workbench-material-editor-relative {
    position: relative;
  }
  .workbench-material-editor-ticon {
    z-index: 1;
  }
  .workbench-material-editor-neutral-flex {
    flex: 1 1 0px;
  }
  .workbench-material-editor-horizontal-border {
    border-bottom: 1px solid;
    color: inherit;
  }
  .workbench-material-editor-general-attribute-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: repeat(9, 1fr);
    grid-auto-rows: minmax(min-content, max-content);
    grid-auto-flow: column;
    grid-column-gap: 32px;
    grid-row-gap: 8px;
  }
</style>
